import React from 'react';
import { ReactComponent as Matrics } from 'assets/icons/MarketMetrics.svg';
import { ReactComponent as MatricsCard2 } from 'assets/icons/market-metrics-2.svg';
import { ReactComponent as MatricsCard3 } from 'assets/icons/market-metrics-3.svg';
import { Grid, Typography, Box, useMediaQuery } from '@mui/material';
import {
  fontsize16,
  fontsize20,
  poppins400,
  poppins500,
  poppins700,
} from 'theme/common.style';
import { useTheme } from '@mui/styles';

export const MarketMetricsGraphOne = () => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <Grid
        container
        sx={{
          p: 1.2,
          display: 'flex',
          flexDirection: 'column',
          width: matchessm ? '100%' : '318px',
          paddingTop: '13px',
        }}
      >
        <Grid
          sx={{
            marginRight: '1px',
            backgroundColor: '#F7F8F7',
            padding: '10px 0px',
            borderRadius: '15px',
          }}
        >
          <Grid sx={{ width: '221px', height: '111px', paddingLeft: '8px' }}>
            <Matrics />
          </Grid>
          <Grid sx={{ marginTop: '20px' }}>
            <Typography
              style={{ marginLeft: '55px' }}
              sx={{ ...poppins500, ...fontsize20 }}
            >
              Auction Clearance
            </Typography>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '67px',
              marginLeft: '13px',
            }}
          >
            <Box sx={{}}>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Auction Results - 2026
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ ...poppins700, ...fontsize16 }}>87</Typography>
            </Box>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '143px',
              marginLeft: '13px',
            }}
          >
            <Box>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Private Sales
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ ...poppins700, ...fontsize16 }}>30</Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export const MarketMetricsGraphTwo = () => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Grid
        container
        sx={{
          p: 1.2,
          display: 'flex',
          flexDirection: 'column',
          width: matchessm ? '100%' : '318px',
        }}
      >
        <Grid
          sx={{
            marginRight: '1px',
            backgroundColor: '#F7F8F7',
            padding: '10px 0px',
            borderRadius: '15px',
          }}
        >
          <Grid sx={{ width: '221px', height: '111px', marginLeft: '28px' }}>
            <MatricsCard2 />
          </Grid>
          <Grid sx={{ marginTop: '20px' }}>
            <Typography
              style={{ marginLeft: '22px' }}
              sx={{ ...poppins500, ...fontsize20 }}
            >
              Average Days on Market
            </Typography>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '75px',
              marginLeft: '13px',
            }}
          >
            <Box sx={{}}>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Overall Market - 2026
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ ...poppins700, ...fontsize16 }}>87</Typography>
            </Box>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '90px',
              marginLeft: '13px',
            }}
          >
            <Box>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Direct Comparable
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ ...poppins700, ...fontsize16 }}>30</Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export const MarketMetricsGraphThree = () => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Grid
        container
        sx={{
          p: 1.2,
          display: 'flex',
          flexDirection: 'column',
          width: matchessm ? '100%' : '318px',
        }}
      >
        <Grid
          sx={{
            marginRight: '1px',
            backgroundColor: '#F7F8F7',
            padding: '10px 0px',
            borderRadius: '15px',
          }}
        >
          <Grid sx={{ width: '221px', height: '111px', marginLeft: '28px' }}>
            <MatricsCard3 />
          </Grid>
          <Grid sx={{ marginTop: '20px' }}>
            <Typography
              style={{ marginLeft: '62px' }}
              sx={{ ...poppins500, ...fontsize20, color: '#1D2125' }}
            >
              Number of stock
            </Typography>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '75px',
              marginLeft: '13px',
            }}
          >
            <Box sx={{}}>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Overall Market - 2026
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ ...poppins700, ...fontsize16 }}>87</Typography>
            </Box>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '90px',
              marginLeft: '13px',
            }}
          >
            <Box>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Direct Comparable
              </Typography>
            </Box>
            <Box>
              <Typography sx={{ ...poppins700, ...fontsize16 }}>30</Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export const MarketMetricsGraphFour = () => {
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      <Grid
        container
        sx={{
          p: 1.2,
          display: 'flex',
          flexDirection: 'column',
          width: matchessm ? '100%' : '318px',
        }}
      >
        <Grid
          sx={{
            marginRight: '1px',
            backgroundColor: '#F7F8F7',
            padding: '10px 0px',
            borderRadius: '15px',
          }}
        >
          <Grid sx={{ width: '221px', height: '111px', marginLeft: '28px' }}>
            <MatricsCard2 />
          </Grid>
          <Grid sx={{ marginTop: '20px' }}>
            <Typography
              style={{ marginLeft: '56px' }}
              sx={{ ...poppins500, ...fontsize20, color: '#1D2125' }}
            >
              Market sentiment
            </Typography>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '5px',
              marginLeft: '13px',
            }}
          >
            <Box sx={{}}>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Overall Market - 2026
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ ...poppins700, ...fontsize16, color: '#1D2125' }}
              >
                Med to High
              </Typography>
            </Box>
          </Grid>
          <Grid
            sx={{
              marginTop: '10px',
              display: 'flex',
              gap: '80px',
              marginLeft: '13px',
            }}
          >
            <Box>
              <Typography sx={{ ...poppins400, ...fontsize16 }}>
                Direct Comparable
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{ ...poppins700, ...fontsize16, color: '#1D2125' }}
              >
                High
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
